import { Col, ScreenReaderOnly } from '@op/opds.opux';
import styles from './PriceSummary.module.scss';
import { DiscountType, type Premium } from 'dto/CoveragePremium';
import { type CoverageProduct } from 'dto/marketableProduct';
import i18n from 'i18n';
import DiscountAction, {
  type CustomerType,
} from 'individual/components/common/DiscountAction';
import { formatEuros } from 'utils';

const getDiscountTextKey = (
  discountName: DiscountType,
  customerType?: CustomerType
): string => {
  if (discountName === DiscountType.DISCRETIONARY_DISCOUNT) {
    return customerType && customerType !== 'unAuthenticated'
      ? `priceSummary.discountLabel.${DiscountType.DISCRETIONARY_DISCOUNT}_AUTHENTICATED`
      : `priceSummary.discountLabel.${DiscountType.DISCRETIONARY_DISCOUNT}_UNAUTHENTICATED`;
  } else if (discountName === DiscountType.WAIT_PERIOD_DISCOUNT) {
    return 'priceSummary.discountLabel.WAIT_PERIOD_DISCOUNT';
  }
  return '';
};

export const CoverageProductPriceSummary = (props: {
  coverageProduct: CoverageProduct;
  premium: Premium;
  customerType?: CustomerType;
}) => (
  <>
    <div className={styles.rowDisplay}>
      <dt>
        <Col xs={6}>
          {i18n.t(`coverageProduct.${props.coverageProduct}.name`)}
        </Col>
      </dt>
      <dd>
        <Col
          xs={6}
          className={styles.noWrap}
          data-testid={`coverageProduct-${props.coverageProduct}-price`}>
          {formatEuros(props.premium.monthlyGrossPremium.amount, 2).replace(
            '€',
            ''
          )}
          {i18n.t('common.eurosPerMonth')}
        </Col>
      </dd>
    </div>
    {props.premium.discounts.map((discount) => {
      return (
        <div key={discount.name} className={styles.rowDisplay}>
          <dt>
            <Col xs={6}>
              <div className={styles.benefit}>
                <ScreenReaderOnly>
                  {i18n.t(
                    'coverageProduct.' + props.coverageProduct + '.name'
                  ) + ', '}
                </ScreenReaderOnly>
                <DiscountAction
                  discount={discount}
                  discountType={discount.name}
                  customerType={props.customerType}
                  textKey={getDiscountTextKey(
                    discount.name,
                    props.customerType
                  )}
                />
              </div>
            </Col>
          </dt>
          <dd>
            <Col
              xs={6}
              className={styles.noWrap}
              data-testid={`coverageProduct-${props.coverageProduct}-${discount.name}`}>
              {formatEuros(discount.monthlyValue, 2).replace('€', '')}
              {i18n.t('common.eurosPerMonth')}
            </Col>
          </dd>
        </div>
      );
    })}
  </>
);
